import { CommonModule } from '@angular/common';
import { AfterContentInit, Component, EventEmitter, Input, NO_ERRORS_SCHEMA, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule, KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import { IconsModule, KENDO_ICONS } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { KENDO_LABELS, LabelModule } from '@progress/kendo-angular-label';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import { LoggerService } from '../../shared/logger.service';
import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { Subscription } from 'rxjs';
import { storyOptions, StoryOptionType, UserStorySearchOptions } from '../../common/obj.lib';
import {
  CasiOwnerUser,
  CasiProjectLabel,
  CasiStoryEstimate, CasiStoryPriority, CasiStoryStatus, CasiStoryType,
  Project,
  User as UserModel
} from '../../models/models.lib';
import { IconName, IconPrefix, IconProp } from '@fortawesome/fontawesome-svg-core';
import { AutoFocusDirective } from '../../directives/auto-focus.directive';

@Component({
  selector: 'casi-searcher',
  standalone: true,
  imports: [
    CommonModule,
    LayoutModule,
    ButtonsModule,
    IndicatorsModule,
    RouterModule,
    IconsModule,
    NavigationModule,
    FormsModule,
    ReactiveFormsModule,
    DropDownsModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    LabelModule,
    InputsModule,
    AutoFocusDirective,
    KENDO_ICONS,
    KENDO_DROPDOWNS,
    KENDO_LABELS
  ],
  schemas: [NO_ERRORS_SCHEMA],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './searcher.component.html',
  styleUrl: './searcher.component.scss'
})
export class SearcherComponent implements OnInit, OnDestroy, AfterContentInit, OnChanges {

  @Input() showProjects: boolean = false;
  @Input() projects: Project[] = [];

  private initalSearchOptions: UserStorySearchOptions = new UserStorySearchOptions({});
  private _searchOptions: UserStorySearchOptions | undefined = new UserStorySearchOptions({});
  @Input() set searchOptions(val: UserStorySearchOptions | undefined) {
    this._searchOptions = val || new UserStorySearchOptions({});
    // if (val)
    //   this.initalSearchOptions = val;
    this.form.patchValue(this._searchOptions);
    this.resetSelectedValues();
    // this.selectTypeIconClass = this.setStoryIcons();
    // this.selectedRequester = this._searchOptions.requestedByUserId;
    // this.selectedStoryOption = this._searchOptions.dashboardStr || storyOptions[0].value;
    // this.selectedProjectId = this._searchOptions.projectId;
    // this.selectedOwnerId = this._searchOptions.ownedByUserId;
    // this.logger.debug(`searchOptions:initial: `, this.initalSearchOptions);
  }
  get searchOptions() {
    return this._searchOptions;
  };

  set searchOptionsProject(val: number | undefined) {
    if (this._searchOptions) {
      this._searchOptions.projectId = val;
      this.form.patchValue(this._searchOptions);
    }
  }
  private _users: UserModel[] = [];
  @Input({ required: true }) set users(value: UserModel[]) {
    // this.logger.debug(`set users: `, value);
    this._users = value;
  }
  get users() {
    return this._users;
  }

  // @Input({ required: true }) public storyStatuses: CasiStoryStatus[] = [];
  private _storyTypes: CasiStoryType[] = [];
  @Input({ required: true }) set storyTypes(val: CasiStoryType[]) {
    this._storyTypes = val;
    this.setStoryIcons();
  }
  get storyTypes() {
    return this._storyTypes;
  } //storyTypes: StoryType[] = [];
  @Input({ required: true }) public storyPriorities: CasiStoryPriority[] = [];
  @Input({ required: true }) public storyEstimates: CasiStoryEstimate[] = [];

  private _projectLables: CasiProjectLabel[] = [];
  @Input({ required: true }) set projectLabels(val: CasiProjectLabel[]) {
    this.allProjectLabels = val;
    if (val) {
      this.setProjectLabels(val);
    } else {
      this.setProjectLabels([]);
    }
  }
  get projectLabels() {
    return this._projectLables;
  }; //public projectLabels: CasiProjectLabel[] = [];

  @Output() onSearch: EventEmitter<FormGroup> = new EventEmitter();

  form: FormGroup;

  public currentProject: Project | undefined;
  public storyOptions = storyOptions;

  public modUsers: CasiOwnerUser[] = [];

  public defaultDropdownItem: { text: string; id: number | undefined } = {
    text: "Select ...",
    id: undefined
  };

  public defaultStoryItem: { text: string; value: number | undefined } = {
    text: "Select ...",
    value: undefined
  };

  public defaultProjectItem: { project_name: string; id: number | undefined } = {
    project_name: "Select ...",
    id: undefined
  };

  public defaultStoryTypeItem: {
    text: string; id: number | null; user_story_type_description: string;
    iconClass: string | undefined; icon: string | undefined
  } = {
      text: "Select ...",
      id: null,
      user_story_type_description: '',
      iconClass: undefined,
      icon: undefined
    };

  public defaultRequesterItem: {
    text: string; id: number | null; fullName: string;
    initials: string;
  } = {
      text: "Select ...",
      id: null,
      fullName: '',
      initials: ''
    };

  public defaultOwnerItem: {
    user_id: number | null,
    fullName: string,
    initials: string
  } = {
      user_id: null,
      fullName: 'Select Owner ...',
      initials: ''
    };

  public selectedOwners: CasiOwnerUser[] = []; // any = []; //ICasiOwner[] = [];
  public selectedStoryOption: string = storyOptions[0].value;
  public selectedType: number | undefined; // = StoryTypes.Bug;
  public selectTypeIconClass: string | undefined;
  public selectedPriority: string | undefined; // = StoryPriorities.None;
  public selectedRequester: number | undefined;
  public selectedStatus: number | undefined;
  public selectedEstimate: number | undefined;
  public selectedProjectId: number | undefined;
  public selectedOwnerId: number | undefined;
  public selectedProjectLabel: number | undefined;
  public selectedStory: string | undefined;

  public iconList: IconProp | undefined;

  private allProjectLabels: CasiProjectLabel[] = [];

  private _subs: Subscription[] = [];

  constructor(
    private logger: LoggerService,
    public faIcons: FaIconLibrary,
    private fb: FormBuilder,
  ) {
    faIcons.addIcons(...all);
    this.form = this.fb.group(
      {
        searchStr: [null, []],
        dashboardStr: [null, [Validators.required]],
        projectId: [null, []],
        projectLabelId: [null, []],
        userStoryTypeId: [null, []],
        userStoryEstimateId: [null, []],
        userStoryPriorityId: [null, []],
        requestedByUserId: [null, []],
        ownedByUserId: [null, []],
      }
    );
  }

  //#region Form

  get f() {
    return this.form.controls;
  }
  get searchStr() {
    return this.form.get('searchStr');
  }
  get dashboardStr() {
    return this.form.get('dashboardStr');
  }
  get projectId() {
    return this.form.get('projectId');
  }
  get projectLabelId() {
    return this.form.get('projectLabelId');
  }
  get userStoryTypeId() {
    return this.form.get('userStoryTypeId');
  }
  get userStoryEstimateId() {
    return this.form.get('userStoryEstimateId');
  }
  get userStoryPriorityId() {
    return this.form.get('userStoryPriorityId');
  }
  get requestedByUserId() {
    return this.form.get('requestedByUserId');
  }
  get ownedByUserId() {
    return this.form.get('ownedByUserId');
  }

  //#endregion

  //#region Ng Event Handlers

  ngOnChanges(changes: SimpleChanges): void {
    // this.logger.debug('ngOnChanges...', changes);
    const { searchOptions } = changes;
    // this.logger.debug('ngOnChanges:searchOptions', searchOptions);
    if (searchOptions) {
      const { currentValue } = searchOptions;
      if (currentValue) {
        if (!!currentValue.projectId) {
          this.searchForProject(currentValue.projectId);
        }
      } else {
        this.searchForProject();
      }
    }
  }

  ngAfterContentInit(): void {
    // this.logger.debug('ngAfterContentInit...');

    this.users.forEach((u) => {
      this.modUsers.push(CasiOwnerUser.createFromUser(u)); //{user_id: u.id, fullName: u.fullName, initials: u.initials});
    });

  }

  ngOnDestroy(): void {
    // this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }

  ngOnInit(): void {
    // this.logger.debug('ngOnInit...', this.constructor.name);
  }

  //#endregion

  public clearForm(): void {
    this.logger.debug(`clearForm...`, this.searchOptions);
    this.form.reset();
    this.searchOptions = new UserStorySearchOptions({
      ...this.searchOptions, ...{
        searchStr: undefined,
        projectLabelId: undefined,
        userStoryTypeId: undefined,
        userStoryEstimateId: undefined,
        userStoryPriorityId: undefined,
        requestedByUserId: undefined,
        ownedByUserId: undefined
      }
    }); // new UserStorySearchOptions({
    if (this.showProjects) {
      this.searchOptions = new UserStorySearchOptions({
        ...this.searchOptions, ...{
          dashboardStr: storyOptions[0].value,
          projectId: undefined,
        }
      }); // new UserStorySearchOptions({
    }
    // this.searchOptions = this.initalSearchOptions;
    if (this.searchOptions)
      this.form.patchValue(this.searchOptions);
    this.logger.debug(`clearForm:options: `, this.searchOptions);
    this.resetSelectedValues();
  }

  public projectValueChange(value: any): void {
    // this.logger.debug(`projectValueChange...`, value);
    this.setCurrentProject(value);
  }

  public selectionChange(evnt: any) {
    // this.logger.debug(`selectionChange: `, evnt);
    // this.logger.debug(`selectionChange: `, !!evnt.id);
    if (!!evnt.id === true) {
      this.selectedType = evnt.id;
      this.setStoryIcons();
    }
  }

  public applySearch(): void {
    // this.logger.debug(`applySearch...`, this.form.value);
    if (this.form.status !== 'INVALID')
      this.onSearch.emit(this.form);
  }

  private setStoryIcons(): any {
    // this.logger.debug(`setStoryIcons...storyTypes:`, this.storyTypes);
    // this.logger.debug(`setStoryIcons...selectedType`, this.selectedType);
    if (this.storyTypes) {
      let found = this.storyTypes.find(st => st.id === this.selectedType);
      if (found) {
        this.iconList = [('fad' as IconPrefix), (found.icon as IconName)];
        setTimeout(() => {
          this.selectTypeIconClass = found.iconClass;
        });
      }
      // this.logger.debug(`setStoryIcons: selectTypeIcons`, this.selectTypeIconClass);
    }
  }

  private setProjectLabels(vals: CasiProjectLabel[]) {
    // this.logger.debug(`setProjectLabels:val: `, vals);
    // this.logger.debug(`setProjectLabels:searchOptions: `, this.searchOptions);
    if (this.searchOptions) {
      this._projectLables = vals.filter((p) => p.project_id === this.searchOptions?.projectId);
    } else {
      this._projectLables = vals;
    }
    // this.logger.debug(`setProjectLables: `, this.projectLabels);
  }

  private setCurrentProject(project?: Project) {
    // this.logger.debug(`setCurrentProject: `, project);
    if (project && project.id) {
      // this.currentProject = project;
      this.searchOptionsProject = project.id;
    } else {
      // this.currentProject = undefined;
      this.searchOptionsProject = undefined;
    }
    this.setProjectLabels(this.allProjectLabels);
  }

  private searchForProject(id?: number) {
    let foundProject: Project | undefined;
    if (!!id && this.projects) {
      foundProject = this.projects.find(p => p.id === this.searchOptions?.projectId);// this.searchOptions
    }
    this.setCurrentProject(foundProject);
  }

  private resetSelectedValues(): void {

    this.selectTypeIconClass = this.setStoryIcons();
    if (this.searchOptions) {
      this.selectedType = this.searchOptions.userStoryTypeId;
      this.selectedRequester = this.searchOptions.requestedByUserId;
      this.selectedStoryOption = this.searchOptions.dashboardStr || storyOptions[0].value;
      this.selectedProjectId = this.searchOptions.projectId;
      this.selectedOwnerId = this.searchOptions.ownedByUserId;
      this.selectedStory = this.searchOptions.dashboardStr;
    }

  }

}
